import { crypto_logo } from "../Services/apiRoutes";

export const getCryptoLogoMap = async (coinSymbolList) => {
  coinSymbolList = coinSymbolList.map(element => element.trim().toUpperCase());

  const missingCoins = coinSymbolList.filter(symbol => !coinIconMap[symbol.trim().toUpperCase()]);


  if (missingCoins.length > 0) {
    let coinsResponse = await crypto_logo(missingCoins);

    if (coinsResponse["status"] === true) {
      // let result = {};
      coinsResponse["data"].forEach(function (val) {
        const symbol = val.symbol.trim().toUpperCase();
        const logo = val.logo.trim();
        if (symbol && logo) {
          coinIconMap[symbol] = logo;
        }

        // result[val["symbol"]] = val["logo"];
      });

      // return result;
    } else {
      console.error("Unexpected structure for coinsResponse:", coinsResponse);
      // return {};
    }
  }
  return coinIconMap;

};

const coinIconMap = {
  "BTC": "https://s2.coinmarketcap.com/static/img/coins/64x64/1.png",
  "PYUSD": "https://s2.coinmarketcap.com/static/img/coins/64x64/27772.png",
  "ETH": "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
  "EV": "https://s2.coinmarketcap.com/static/img/coins/64x64/9805.png",
  "USDT": "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
  "AI": "https://s2.coinmarketcap.com/static/img/coins/64x64/11061.png",
  "BUSD": "https://s2.coinmarketcap.com/static/img/coins/64x64/4687.png",
  "ID": "https://s2.coinmarketcap.com/static/img/coins/64x64/21846.png",
  "CRYPTO": "https://s2.coinmarketcap.com/static/img/coins/64x64/27850.png",
  "XRP": "https://s2.coinmarketcap.com/static/img/coins/64x64/52.png",
  "NEFTY": "https://s2.coinmarketcap.com/static/img/coins/64x64/23224.png",
  "USDC": "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
  "ASSET": "https://s2.coinmarketcap.com/static/img/coins/64x64/20344.png",
  "DEX": "https://s2.coinmarketcap.com/static/img/coins/64x64/20343.png",
  "SOL": "https://s2.coinmarketcap.com/static/img/coins/64x64/5426.png",
  "WETH": "https://s2.coinmarketcap.com/static/img/coins/64x64/2396.png",
  "\$AI": "https://s2.coinmarketcap.com/static/img/coins/64x64/23582.png",
  "SECT": "https://s2.coinmarketcap.com/static/img/coins/64x64/24059.png",
  "USTC": "https://s2.coinmarketcap.com/static/img/coins/64x64/7129.png",
  "LUNC": "https://s2.coinmarketcap.com/static/img/coins/64x64/4172.png",
  "UST": "https://s2.coinmarketcap.com/static/img/coins/64x64/3100.png",
  "METAV": "https://s2.coinmarketcap.com/static/img/coins/64x64/13978.png",
  "BITCOIN": "https://s2.coinmarketcap.com/static/img/coins/64x64/25220.png",
  "DOGECOIN": "https://s2.coinmarketcap.com/static/img/coins/64x64/12040.png",
  "ETHEREUM": "https://s2.coinmarketcap.com/static/img/coins/64x64/27873.png",
  "SOLANA": "https://s2.coinmarketcap.com/static/img/coins/64x64/27755.png",
  "CEO": "https://s2.coinmarketcap.com/static/img/coins/64x64/23677.png",
  "MANA": "https://s2.coinmarketcap.com/static/img/coins/64x64/1966.png",
  "MATIC": "https://s2.coinmarketcap.com/static/img/coins/64x64/3890.png",
  "NEAR": "https://s2.coinmarketcap.com/static/img/coins/64x64/6535.png",
  "EFT": "https://s2.coinmarketcap.com/static/img/coins/64x64/16143.png",
  "NFT": "https://s2.coinmarketcap.com/static/img/coins/64x64/9816.png",
  "LIQUID": "https://s2.coinmarketcap.com/static/img/coins/64x64/4470.png",
  "CURVE": "https://s2.coinmarketcap.com/static/img/coins/64x64/24614.png",
  "FTX": "https://s2.coinmarketcap.com/static/img/coins/64x64/2667.png",
  "AMA": "https://s2.coinmarketcap.com/static/img/coins/64x64/21168.png",
  "NFTB": "https://s2.coinmarketcap.com/static/img/coins/64x64/9545.png",
  "GEL": "https://s2.coinmarketcap.com/static/img/coins/64x64/7229.png",
  "CLO": "https://s2.coinmarketcap.com/static/img/coins/64x64/2757.png",
  "SEBA": "https://s2.coinmarketcap.com/static/img/coins/64x64/19116.png",
  "TC": "https://s2.coinmarketcap.com/static/img/coins/64x64/12532.png",
  "BTP": "https://s2.coinmarketcap.com/static/img/coins/64x64/19376.png",
  "PAYU": "https://s2.coinmarketcap.com/static/img/coins/64x64/25736.png",
  "XX": "https://s2.coinmarketcap.com/static/img/coins/64x64/18995.png",
  "PEEL": "https://s2.coinmarketcap.com/static/img/coins/64x64/21013.png",
  "HOPR": "https://s2.coinmarketcap.com/static/img/coins/64x64/6520.png",
  "NXRA": "https://s2.coinmarketcap.com/static/img/coins/64x64/23825.png",
  "BTSE": "https://s2.coinmarketcap.com/static/img/coins/64x64/5305.png",
  "XDC": "https://s2.coinmarketcap.com/static/img/coins/64x64/2634.png",
  "DEXT": "https://s2.coinmarketcap.com/static/img/coins/64x64/5866.png",
  "KLAY": "https://s2.coinmarketcap.com/static/img/coins/64x64/4256.png",
  "MPL": "https://s2.coinmarketcap.com/static/img/coins/64x64/9417.png",
  "VEGA": "https://s2.coinmarketcap.com/static/img/coins/64x64/10223.png",
  "POND": "https://s2.coinmarketcap.com/static/img/coins/64x64/7497.png",
  "X": "https://s2.coinmarketcap.com/static/img/coins/64x64/27704.png",
  "QUICK": "https://s2.coinmarketcap.com/static/img/coins/64x64/19966.png",
  "KDA": "https://s2.coinmarketcap.com/static/img/coins/64x64/5647.png",
  "TRX": "https://s2.coinmarketcap.com/static/img/coins/64x64/1958.png",
  "KNC": "https://s2.coinmarketcap.com/static/img/coins/64x64/9444.png",
  "ACH": "https://s2.coinmarketcap.com/static/img/coins/64x64/6958.png",
  "OCEAN": "https://s2.coinmarketcap.com/static/img/coins/64x64/3911.png",
  "FIDA": "https://s2.coinmarketcap.com/static/img/coins/64x64/7978.png",
  "ICP": "https://s2.coinmarketcap.com/static/img/coins/64x64/8916.png",
  "SSV": "https://s2.coinmarketcap.com/static/img/coins/64x64/12999.png",
  "BSW": "https://s2.coinmarketcap.com/static/img/coins/64x64/10746.png",
  "RAIN": "https://s2.coinmarketcap.com/static/img/coins/64x64/15926.png",
  "PC": "https://s2.coinmarketcap.com/static/img/coins/64x64/13249.png",
  "MLS": "https://s2.coinmarketcap.com/static/img/coins/64x64/20262.png",
  "BNB": "https://s2.coinmarketcap.com/static/img/coins/64x64/1839.png",
  "API3": "https://s2.coinmarketcap.com/static/img/coins/64x64/7737.png",
  "VC": "https://s2.coinmarketcap.com/static/img/coins/64x64/24254.png",
  "RNDR": "https://s2.coinmarketcap.com/static/img/coins/64x64/5690.png",
  "IQ": "https://s2.coinmarketcap.com/static/img/coins/64x64/2930.png",
  "RBIF": "https://s2.coinmarketcap.com/static/img/coins/64x64/15098.png",
  "DYDX": "https://s2.coinmarketcap.com/static/img/coins/64x64/11156.png",
  "RUN": "https://s2.coinmarketcap.com/static/img/coins/64x64/19638.png",
  "SHIB": "https://s2.coinmarketcap.com/static/img/coins/64x64/5994.png",
  "XETA": "https://s2.coinmarketcap.com/static/img/coins/64x64/20286.png",
  "HEART": "https://s2.coinmarketcap.com/static/img/coins/64x64/15584.png",
  "LBL": "https://s2.coinmarketcap.com/static/img/coins/64x64/12988.png",
  "TKX": "https://s2.coinmarketcap.com/static/img/coins/64x64/4715.png",
  "ERG": "https://s2.coinmarketcap.com/static/img/coins/64x64/1762.png",
  "MIX": "https://s2.coinmarketcap.com/static/img/coins/64x64/4366.png",
  "PRIME": "https://s2.coinmarketcap.com/static/img/coins/64x64/23711.png",
  "BabyDoge": "https://s2.coinmarketcap.com/static/img/coins/64x64/10407.png",
  "CKB": "https://s2.coinmarketcap.com/static/img/coins/64x64/4948.png",
  "ZIG": "https://s2.coinmarketcap.com/static/img/coins/64x64/9260.png",
  "BGB": "https://s2.coinmarketcap.com/static/img/coins/64x64/11092.png",
  "EDGE": "https://s2.coinmarketcap.com/static/img/coins/64x64/2535.png",
  "WEMIX": "https://s2.coinmarketcap.com/static/img/coins/64x64/7548.png",
  "NYM": "https://s2.coinmarketcap.com/static/img/coins/64x64/17591.png",
  "TLM": "https://s2.coinmarketcap.com/static/img/coins/64x64/9119.png",
  "REEF": "https://s2.coinmarketcap.com/static/img/coins/64x64/6951.png",
  "DODO": "https://s2.coinmarketcap.com/static/img/coins/64x64/7224.png",
  "THETA": "https://s2.coinmarketcap.com/static/img/coins/64x64/2416.png",
  "DOGE": "https://s2.coinmarketcap.com/static/img/coins/64x64/74.png",
  "CELO": "https://s2.coinmarketcap.com/static/img/coins/64x64/5567.png",
  "HNT": "https://s2.coinmarketcap.com/static/img/coins/64x64/5665.png",
  "VRA": "https://s2.coinmarketcap.com/static/img/coins/64x64/3816.png",
  "VET": "https://s2.coinmarketcap.com/static/img/coins/64x64/3077.png",
  "UNI": "https://s2.coinmarketcap.com/static/img/coins/64x64/7083.png",
  "OPX": "https://s2.coinmarketcap.com/static/img/coins/64x64/22673.png",
  "ALPACA": "https://s2.coinmarketcap.com/static/img/coins/64x64/8707.png",
  "JOE": "https://s2.coinmarketcap.com/static/img/coins/64x64/11396.png",
  "DUSD": "https://s2.coinmarketcap.com/static/img/coins/64x64/18861.png",
  "DFI": "https://s2.coinmarketcap.com/static/img/coins/64x64/5804.png",
  "SUI": "https://s2.coinmarketcap.com/static/img/coins/64x64/20947.png",
  "TKO": "https://s2.coinmarketcap.com/static/img/coins/64x64/9020.png",
  "ARPA": "https://s2.coinmarketcap.com/static/img/coins/64x64/4039.png",
  "NVIR": "https://s2.coinmarketcap.com/static/img/coins/64x64/15924.png",
  "OPTI": "https://s2.coinmarketcap.com/static/img/coins/64x64/23794.png",
  "XCH": "https://s2.coinmarketcap.com/static/img/coins/64x64/9258.png",
  "TLOS": "https://s2.coinmarketcap.com/static/img/coins/64x64/4660.png",
  "FLOKI": "https://s2.coinmarketcap.com/static/img/coins/64x64/10804.png",
  "DEXE": "https://s2.coinmarketcap.com/static/img/coins/64x64/7326.png",
  "XPNET": "https://s2.coinmarketcap.com/static/img/coins/64x64/11752.png",
  "NEO": "https://s2.coinmarketcap.com/static/img/coins/64x64/1376.png",
  "CAKE": "https://s2.coinmarketcap.com/static/img/coins/64x64/7186.png",
  "GLMR": "https://s2.coinmarketcap.com/static/img/coins/64x64/6836.png",
  "POL": "https://s2.coinmarketcap.com/static/img/coins/64x64/6297.png",
  "SEI": "https://s2.coinmarketcap.com/static/img/coins/64x64/23149.png",
  "FOMO": "https://s2.coinmarketcap.com/static/img/coins/64x64/19261.png",
  "TT": "https://s2.coinmarketcap.com/static/img/coins/64x64/3930.png",
  "BGT": "https://s2.coinmarketcap.com/static/img/coins/64x64/23105.png",
  "OP": "https://s2.coinmarketcap.com/static/img/coins/64x64/11840.png",
  "USP": "https://s2.coinmarketcap.com/static/img/coins/64x64/23218.png",
  "DOT": "https://s2.coinmarketcap.com/static/img/coins/64x64/6636.png",
  "XCM": "https://s2.coinmarketcap.com/static/img/coins/64x64/4105.png",
  "SUSHI": "https://s2.coinmarketcap.com/static/img/coins/64x64/6758.png",
  "ONE": "https://s2.coinmarketcap.com/static/img/coins/64x64/3945.png",
  "ENS": "https://s2.coinmarketcap.com/static/img/coins/64x64/13855.png",
  "XPLA": "https://s2.coinmarketcap.com/static/img/coins/64x64/22359.png",
  "CPOOL": "https://s2.coinmarketcap.com/static/img/coins/64x64/12573.png",
  "GALA": "https://s2.coinmarketcap.com/static/img/coins/64x64/7080.png",
  "OPEN": "https://s2.coinmarketcap.com/static/img/coins/64x64/2762.png",
  "STFX": "https://s2.coinmarketcap.com/static/img/coins/64x64/23257.png",
  "D": "https://s2.coinmarketcap.com/static/img/coins/64x64/1769.png",
  "ML": "https://s2.coinmarketcap.com/static/img/coins/64x64/14977.png",
  "CFT": "https://s2.coinmarketcap.com/static/img/coins/64x64/20612.png",
  "EBA": "https://s2.coinmarketcap.com/static/img/coins/64x64/11923.png",
  "L2": "https://s2.coinmarketcap.com/static/img/coins/64x64/7772.png",
  "API": "https://s2.coinmarketcap.com/static/img/coins/64x64/7909.png",
  "SC": "https://s2.coinmarketcap.com/static/img/coins/64x64/1042.png",
  "JP": "https://s2.coinmarketcap.com/static/img/coins/64x64/23453.png",
  "ADX": "https://s2.coinmarketcap.com/static/img/coins/64x64/1768.png",
  "EDX": "https://s2.coinmarketcap.com/static/img/coins/64x64/23918.png",
  "SKL": "https://s2.coinmarketcap.com/static/img/coins/64x64/5691.png",
  "FIL": "https://s2.coinmarketcap.com/static/img/coins/64x64/2280.png",
  "CAP": "https://s2.coinmarketcap.com/static/img/coins/64x64/5809.png",
  "OG": "https://s2.coinmarketcap.com/static/img/coins/64x64/5309.png",
  "DUSK": "https://s2.coinmarketcap.com/static/img/coins/64x64/4092.png",
  "VIP": "https://s2.coinmarketcap.com/static/img/coins/64x64/14562.png",
  "ZBC": "https://s2.coinmarketcap.com/static/img/coins/64x64/18860.png",
  "YAY": "https://s2.coinmarketcap.com/static/img/coins/64x64/11664.png",
  "ARK": "https://s2.coinmarketcap.com/static/img/coins/64x64/1586.png",
  "ETC": "https://s2.coinmarketcap.com/static/img/coins/64x64/1321.png",
  "MOD": "https://s2.coinmarketcap.com/static/img/coins/64x64/8494.png",
  "LTC": "https://s2.coinmarketcap.com/static/img/coins/64x64/2.png",
  "RAP": "https://s2.coinmarketcap.com/static/img/coins/64x64/7832.png",
  "YGG": "https://s2.coinmarketcap.com/static/img/coins/64x64/10688.png",
  "AKT": "https://s2.coinmarketcap.com/static/img/coins/64x64/7431.png",
  "GRT": "https://s2.coinmarketcap.com/static/img/coins/64x64/6719.png",
  "MORE": "https://s2.coinmarketcap.com/static/img/coins/64x64/17733.png",
  "FGC": "https://s2.coinmarketcap.com/static/img/coins/64x64/2870.png",
  "NEU": "https://s2.coinmarketcap.com/static/img/coins/64x64/23296.png",
  "ANT": "https://s2.coinmarketcap.com/static/img/coins/64x64/1680.png",
  "OWN": "https://s2.coinmarketcap.com/static/img/coins/64x64/3120.png",
  "TAB": "https://s2.coinmarketcap.com/static/img/coins/64x64/11185.png",
  "LUCK": "https://s2.coinmarketcap.com/static/img/coins/64x64/21160.png",
  "ALP": "https://s2.coinmarketcap.com/static/img/coins/64x64/12360.png",
  "FIS": "https://s2.coinmarketcap.com/static/img/coins/64x64/5882.png",
  "DVT": "https://s2.coinmarketcap.com/static/img/coins/64x64/4027.png",
  "VIA": "https://s2.coinmarketcap.com/static/img/coins/64x64/470.png",
  "SOLD": "https://s2.coinmarketcap.com/static/img/coins/64x64/11297.png",
  "DMC": "https://s2.coinmarketcap.com/static/img/coins/64x64/8610.png",
  "AMM": "https://s2.coinmarketcap.com/static/img/coins/64x64/2286.png",
  "BUY": "https://s2.coinmarketcap.com/static/img/coins/64x64/11750.png",
  "F9": "https://s2.coinmarketcap.com/static/img/coins/64x64/12215.png",
  "PSP": "https://s2.coinmarketcap.com/static/img/coins/64x64/14534.png",
  "GET": "https://s2.coinmarketcap.com/static/img/coins/64x64/2354.png",
  "EVC": "https://s2.coinmarketcap.com/static/img/coins/64x64/2237.png",
  "SCP": "https://s2.coinmarketcap.com/static/img/coins/64x64/4074.png",
  "RPC": "https://s2.coinmarketcap.com/static/img/coins/64x64/19692.png",
  "HEX": "https://s2.coinmarketcap.com/static/img/coins/64x64/5015.png",
  "MIT": "https://s2.coinmarketcap.com/static/img/coins/64x64/17600.png",
  "TOOLS": "https://s2.coinmarketcap.com/static/img/coins/64x64/27860.png",
  "MNT": "https://s2.coinmarketcap.com/static/img/coins/64x64/27075.png",
  "WMNT": "https://s2.coinmarketcap.com/static/img/coins/64x64/27614.png",
  "FUD": "https://s2.coinmarketcap.com/static/img/coins/64x64/23422.png",
  "WAXP": "https://s2.coinmarketcap.com/static/img/coins/64x64/2300.png",
  "ON": "https://s2.coinmarketcap.com/static/img/coins/64x64/7021.png",
  "APY": "https://s2.coinmarketcap.com/static/img/coins/64x64/7227.png",
  "CETH": "https://s2.coinmarketcap.com/static/img/coins/64x64/4338.png",
  "LSHARE": "https://s2.coinmarketcap.com/static/img/coins/64x64/20728.png",
  "LIF3": "https://s2.coinmarketcap.com/static/img/coins/64x64/20611.png",
  "YFI": "https://s2.coinmarketcap.com/static/img/coins/64x64/5864.png",
  "TSHARE": "https://s2.coinmarketcap.com/static/img/coins/64x64/16943.png",
  "FTM": "https://s2.coinmarketcap.com/static/img/coins/64x64/3513.png",
  "ROUTE": "https://s2.coinmarketcap.com/static/img/coins/64x64/8292.png",
  "PDF": "https://s2.coinmarketcap.com/static/img/coins/64x64/6737.png",
  "MP3": "https://s2.coinmarketcap.com/static/img/coins/64x64/8412.png",
  "WSTETH": "https://s2.coinmarketcap.com/static/img/coins/64x64/12409.png",
  "ACE": "https://s2.coinmarketcap.com/static/img/coins/64x64/9792.png",
  "FEI": "https://s2.coinmarketcap.com/static/img/coins/64x64/8642.png",
  "AM": "https://s2.coinmarketcap.com/static/img/coins/64x64/10763.png",
  "LAND": "https://s2.coinmarketcap.com/static/img/coins/64x64/11245.png",
  "HFT": "https://s2.coinmarketcap.com/static/img/coins/64x64/22461.png",
  "PAAL": "https://s2.coinmarketcap.com/static/img/coins/64x64/27178.png",
  "VELA": "https://s2.coinmarketcap.com/static/img/coins/64x64/23248.png",
  "IXT": "https://s2.coinmarketcap.com/static/img/coins/64x64/17131.png",
  "DG": "https://s2.coinmarketcap.com/static/img/coins/64x64/15478.png",
  "ALI": "https://s2.coinmarketcap.com/static/img/coins/64x64/16876.png",
  "CGO": "https://s2.coinmarketcap.com/static/img/coins/64x64/20245.png",
  "MAV": "https://s2.coinmarketcap.com/static/img/coins/64x64/18037.png",
  "SFM": "https://s2.coinmarketcap.com/static/img/coins/64x64/16162.png",
  "MEVFREE": "https://s2.coinmarketcap.com/static/img/coins/64x64/24031.png",
  "ATA": "https://s2.coinmarketcap.com/static/img/coins/64x64/10188.png",
  "TECH": "https://s2.coinmarketcap.com/static/img/coins/64x64/11579.png",
  "AITECH": "https://s2.coinmarketcap.com/static/img/coins/64x64/19055.png",
  "CFG": "https://s2.coinmarketcap.com/static/img/coins/64x64/6748.png",
  "NEWS": "https://s2.coinmarketcap.com/static/img/coins/64x64/4647.png",
  "RPL": "https://s2.coinmarketcap.com/static/img/coins/64x64/2943.png",
  "AZERO": "https://s2.coinmarketcap.com/static/img/coins/64x64/11976.png",
  "BONK": "https://s2.coinmarketcap.com/static/img/coins/64x64/23095.png",
  "ALPH": "https://s2.coinmarketcap.com/static/img/coins/64x64/14878.png",
  "DYOR": "https://s2.coinmarketcap.com/static/img/coins/64x64/13987.png",
  "GEMS": "https://s2.coinmarketcap.com/static/img/coins/64x64/14094.png",
  "AGIX": "https://s2.coinmarketcap.com/static/img/coins/64x64/2424.png",
  "BLZ": "https://s2.coinmarketcap.com/static/img/coins/64x64/2505.png",
  "FLM": "https://s2.coinmarketcap.com/static/img/coins/64x64/7150.png",
  "PUSH": "https://s2.coinmarketcap.com/static/img/coins/64x64/9111.png",
  "PEPE": "https://s2.coinmarketcap.com/static/img/coins/64x64/24478.png",
  "BOB": "https://s2.coinmarketcap.com/static/img/coins/64x64/2889.png",
  "INJ": "https://s2.coinmarketcap.com/static/img/coins/64x64/7226.png",
  "GF": "https://s2.coinmarketcap.com/static/img/coins/64x64/15585.png",
  "RBTC": "https://s2.coinmarketcap.com/static/img/coins/64x64/3626.png",
  "UMA": "https://s2.coinmarketcap.com/static/img/coins/64x64/5617.png",
  "NRK": "https://s2.coinmarketcap.com/static/img/coins/64x64/24638.png",
  "ADA": "https://s2.coinmarketcap.com/static/img/coins/64x64/2010.png",
  "WIT": "https://s2.coinmarketcap.com/static/img/coins/64x64/14925.png",
  "NDB": "https://s2.coinmarketcap.com/static/img/coins/64x64/21119.png",
  "LINK": "https://s2.coinmarketcap.com/static/img/coins/64x64/1975.png",
  "AAA": "https://s2.coinmarketcap.com/static/img/coins/64x64/11392.png",
  "XYZ": "https://s2.coinmarketcap.com/static/img/coins/64x64/10979.png",
  "UFC": "https://s2.coinmarketcap.com/static/img/coins/64x64/11533.png",
  "TH": "https://s2.coinmarketcap.com/static/img/coins/64x64/7636.png",
  "FT": "https://s2.coinmarketcap.com/static/img/coins/64x64/21356.png",
  "AAVE": "https://s2.coinmarketcap.com/static/img/coins/64x64/7278.png",
  "EPS": "https://s2.coinmarketcap.com/static/img/coins/64x64/8938.png",
  "COTI": "https://s2.coinmarketcap.com/static/img/coins/64x64/3992.png",
  "ATOM": "https://s2.coinmarketcap.com/static/img/coins/64x64/3794.png",
  "NTRN": "https://s2.coinmarketcap.com/static/img/coins/64x64/26680.png",
  "CCA": "https://s2.coinmarketcap.com/static/img/coins/64x64/4122.png",
  "CF": "https://s2.coinmarketcap.com/static/img/coins/64x64/27279.png",
  "EVA": "https://s2.coinmarketcap.com/static/img/coins/64x64/10686.png",
  "THE": "https://s2.coinmarketcap.com/static/img/coins/64x64/23335.png",
  "LSD": "https://s2.coinmarketcap.com/static/img/coins/64x64/24063.png",
  "SSE": "https://s2.coinmarketcap.com/static/img/coins/64x64/24876.png",
  "FX": "https://s2.coinmarketcap.com/static/img/coins/64x64/3884.png",
  "QA": "https://s2.coinmarketcap.com/static/img/coins/64x64/11693.png",
  "MELD": "https://s2.coinmarketcap.com/static/img/coins/64x64/13397.png",
  "CTC": "https://s2.coinmarketcap.com/static/img/coins/64x64/5198.png",
  "AC": "https://s2.coinmarketcap.com/static/img/coins/64x64/7382.png",
  "ASIA": "https://s2.coinmarketcap.com/static/img/coins/64x64/12156.png",
  "WALLET": "https://s2.coinmarketcap.com/static/img/coins/64x64/17722.png",
  "VP": "https://s2.coinmarketcap.com/static/img/coins/64x64/17067.png",
  "OK": "https://s2.coinmarketcap.com/static/img/coins/64x64/760.png",
  "FTO": "https://s2.coinmarketcap.com/static/img/coins/64x64/2846.png",
  "MEV": "https://s2.coinmarketcap.com/static/img/coins/64x64/19063.png",
  "CTSI": "https://s2.coinmarketcap.com/static/img/coins/64x64/5444.png",
  "BUMP": "https://s2.coinmarketcap.com/static/img/coins/64x64/11069.png",
  "KST": "https://s2.coinmarketcap.com/static/img/coins/64x64/12458.png",
  "POWER": "https://s2.coinmarketcap.com/static/img/coins/64x64/17437.png",
  "U": "https://s2.coinmarketcap.com/static/img/coins/64x64/21219.png",
  "YOU": "https://s2.coinmarketcap.com/static/img/coins/64x64/27623.png",
  "TRY": "https://s2.coinmarketcap.com/static/img/coins/64x64/12225.png",
  "HELP": "https://s2.coinmarketcap.com/static/img/coins/64x64/3459.png",
  "EOS": "https://s2.coinmarketcap.com/static/img/coins/64x64/1765.png",
  "ALL": "https://s2.coinmarketcap.com/static/img/coins/64x64/8882.png",
  "IDO": "https://s2.coinmarketcap.com/static/img/coins/64x64/12046.png",
  "DCA": "https://s2.coinmarketcap.com/static/img/coins/64x64/24037.png",
  "ATOR": "https://s2.coinmarketcap.com/static/img/coins/64x64/23757.png",
  "CPU": "https://s2.coinmarketcap.com/static/img/coins/64x64/8295.png",
  "NEW": "https://s2.coinmarketcap.com/static/img/coins/64x64/3871.png",
  "SEA": "https://s2.coinmarketcap.com/static/img/coins/64x64/12432.png",
  "TFUEL": "https://s2.coinmarketcap.com/static/img/coins/64x64/3822.png",
  "SMART": "https://s2.coinmarketcap.com/static/img/coins/64x64/1828.png",
  "CPC": "https://s2.coinmarketcap.com/static/img/coins/64x64/9091.png",
  "LBR": "https://s2.coinmarketcap.com/static/img/coins/64x64/24700.png",
  "EQPAY": "https://s2.coinmarketcap.com/static/img/coins/64x64/27573.png",
  "MMM": "https://s2.coinmarketcap.com/static/img/coins/64x64/27223.png",
  "KING": "https://s2.coinmarketcap.com/static/img/coins/64x64/25002.png",
  "VIBE": "https://s2.coinmarketcap.com/static/img/coins/64x64/1983.png",
  "WEB3": "https://s2.coinmarketcap.com/static/img/coins/64x64/16832.png",
  "COLLAB": "https://s2.coinmarketcap.com/static/img/coins/64x64/23649.png",
  "FACT": "https://s2.coinmarketcap.com/static/img/coins/64x64/27103.png",
  "WRT": "https://s2.coinmarketcap.com/static/img/coins/64x64/20894.png",
  "STARS": "https://s2.coinmarketcap.com/static/img/coins/64x64/8996.png",
  "TOP": "https://s2.coinmarketcap.com/static/img/coins/64x64/3826.png",
  "FUEL": "https://s2.coinmarketcap.com/static/img/coins/64x64/2120.png",
  "DLT": "https://s2.coinmarketcap.com/static/img/coins/64x64/1949.png",
  "FUTURE": "https://s2.coinmarketcap.com/static/img/coins/64x64/18006.png",
  "LBT": "https://s2.coinmarketcap.com/static/img/coins/64x64/20964.png",
  "DAI": "https://s2.coinmarketcap.com/static/img/coins/64x64/4943.png",
  "WBTC": "https://s2.coinmarketcap.com/static/img/coins/64x64/3717.png",
  "SCAN": "https://s2.coinmarketcap.com/static/img/coins/64x64/18740.png",
  "REI": "https://s2.coinmarketcap.com/static/img/coins/64x64/19819.png",
  "OMN": "https://s2.coinmarketcap.com/static/img/coins/64x64/23877.png",
  "BABYSHIB": "https://s2.coinmarketcap.com/static/img/coins/64x64/27905.png",
  "FYN": "https://s2.coinmarketcap.com/static/img/coins/64x64/17073.png",
  "IF": "https://s2.coinmarketcap.com/static/img/coins/64x64/10932.png",
  "EPIC": "https://s2.coinmarketcap.com/static/img/coins/64x64/5435.png",
  "GAS": "https://s2.coinmarketcap.com/static/img/coins/64x64/1785.png",
  "ATM": "https://s2.coinmarketcap.com/static/img/coins/64x64/5227.png",
  "RAD": "https://s2.coinmarketcap.com/static/img/coins/64x64/6843.png",
  "SNS": "https://s2.coinmarketcap.com/static/img/coins/64x64/17231.png",
  "METFI": "https://s2.coinmarketcap.com/static/img/coins/64x64/24225.png",
  "PLC": "https://s2.coinmarketcap.com/static/img/coins/64x64/3364.png",
  "DXC": "https://s2.coinmarketcap.com/static/img/coins/64x64/5364.png",
  "WBT": "https://s2.coinmarketcap.com/static/img/coins/64x64/21353.png",
  "TEST": "https://s2.coinmarketcap.com/static/img/coins/64x64/27788.png",
  "HODL": "https://s2.coinmarketcap.com/static/img/coins/64x64/9900.png",
  "IOI": "https://s2.coinmarketcap.com/static/img/coins/64x64/10295.png",
  "Ari10": "https://s2.coinmarketcap.com/static/img/coins/64x64/13936.png",
  "GST": "https://s2.coinmarketcap.com/static/img/coins/64x64/16352.png",
  "GFI": "https://s2.coinmarketcap.com/static/img/coins/64x64/13967.png",
  "PENDLE": "https://s2.coinmarketcap.com/static/img/coins/64x64/9481.png",
  "IV": "https://s2.coinmarketcap.com/static/img/coins/64x64/19071.png",
  "BASE": "https://s2.coinmarketcap.com/static/img/coins/64x64/7838.png",
  "RACA": "https://s2.coinmarketcap.com/static/img/coins/64x64/11346.png",
  "QKC": "https://s2.coinmarketcap.com/static/img/coins/64x64/2840.png",
  "ONT": "https://s2.coinmarketcap.com/static/img/coins/64x64/2566.png",
  "1INCH": "https://s2.coinmarketcap.com/static/img/coins/64x64/8104.png",
  "HBAR": "https://s2.coinmarketcap.com/static/img/coins/64x64/4642.png",
  "FUN": "https://s2.coinmarketcap.com/static/img/coins/64x64/1757.png",
  "XTZ": "https://s2.coinmarketcap.com/static/img/coins/64x64/2011.png",
  "GAL": "https://s2.coinmarketcap.com/static/img/coins/64x64/11877.png",
  "GTC": "https://s2.coinmarketcap.com/static/img/coins/64x64/10052.png",
  "IP3": "https://s2.coinmarketcap.com/static/img/coins/64x64/20909.png",
  "GMX": "https://s2.coinmarketcap.com/static/img/coins/64x64/11857.png",
  "FIRE": "https://s2.coinmarketcap.com/static/img/coins/64x64/8129.png",
  "MC": "https://s2.coinmarketcap.com/static/img/coins/64x64/13523.png",
  "LG": "https://s2.coinmarketcap.com/static/img/coins/64x64/24846.png",
  "ARMY": "https://s2.coinmarketcap.com/static/img/coins/64x64/24716.png",
  "DV": "https://s2.coinmarketcap.com/static/img/coins/64x64/16509.png",
  "AYA": "https://s2.coinmarketcap.com/static/img/coins/64x64/3973.png",
  "SETH": "https://s2.coinmarketcap.com/static/img/coins/64x64/5765.png",
  "QUBE": "https://s2.coinmarketcap.com/static/img/coins/64x64/20467.png",
  "FARM": "https://s2.coinmarketcap.com/static/img/coins/64x64/6859.png",
  "ALTD": "https://s2.coinmarketcap.com/static/img/coins/64x64/24858.png",
  "HUB": "https://s2.coinmarketcap.com/static/img/coins/64x64/21279.png",
  "ZKP": "https://s2.coinmarketcap.com/static/img/coins/64x64/12087.png",
  "ALPHA": "https://s2.coinmarketcap.com/static/img/coins/64x64/7232.png",
  "GCR": "https://s2.coinmarketcap.com/static/img/coins/64x64/1044.png",
  "M": "https://s2.coinmarketcap.com/static/img/coins/64x64/20696.png",
  "CMP": "https://s2.coinmarketcap.com/static/img/coins/64x64/20056.png",
  "BTC2": "https://s2.coinmarketcap.com/static/img/coins/64x64/3974.png",
  "XT": "https://s2.coinmarketcap.com/static/img/coins/64x64/5999.png",
  "AVA": "https://s2.coinmarketcap.com/static/img/coins/64x64/2776.png",
  "FUND": "https://s2.coinmarketcap.com/static/img/coins/64x64/3854.png",
  "EMBER": "https://s2.coinmarketcap.com/static/img/coins/64x64/26702.png",
  "WILD": "https://s2.coinmarketcap.com/static/img/coins/64x64/9674.png",
  "WEST": "https://s2.coinmarketcap.com/static/img/coins/64x64/5159.png",
  "POW": "https://s2.coinmarketcap.com/static/img/coins/64x64/16963.png",
  "IUS": "https://s2.coinmarketcap.com/static/img/coins/64x64/24083.png",
  "SHARE": "https://s2.coinmarketcap.com/static/img/coins/64x64/6868.png",
  "CORE": "https://s2.coinmarketcap.com/static/img/coins/64x64/23254.png",
  "FLASH": "https://s2.coinmarketcap.com/static/img/coins/64x64/8627.png",
  "STEP": "https://s2.coinmarketcap.com/static/img/coins/64x64/17010.png",
  "WATCH": "https://s2.coinmarketcap.com/static/img/coins/64x64/8621.png",
  "RPG": "https://s2.coinmarketcap.com/static/img/coins/64x64/11978.png",
  "SIX": "https://s2.coinmarketcap.com/static/img/coins/64x64/3327.png",
  "FOUR": "https://s2.coinmarketcap.com/static/img/coins/64x64/25049.png",
  "LA": "https://s2.coinmarketcap.com/static/img/coins/64x64/2090.png",
  "XCN": "https://s2.coinmarketcap.com/static/img/coins/64x64/18679.png",
  "HELLO": "https://s2.coinmarketcap.com/static/img/coins/64x64/22320.png",
  "EDNS": "https://s2.coinmarketcap.com/static/img/coins/64x64/27192.png",
  "MARSH": "https://s2.coinmarketcap.com/static/img/coins/64x64/8963.png",
  "FON": "https://s2.coinmarketcap.com/static/img/coins/64x64/21711.png",
  "NULS": "https://s2.coinmarketcap.com/static/img/coins/64x64/2092.png",
  "LST": "https://s2.coinmarketcap.com/static/img/coins/64x64/7623.png",
  "PTC": "https://s2.coinmarketcap.com/static/img/coins/64x64/24115.png",
  "R": "https://s2.coinmarketcap.com/static/img/coins/64x64/24404.png",
  "EUL": "https://s2.coinmarketcap.com/static/img/coins/64x64/14280.png",
  "HAY": "https://s2.coinmarketcap.com/static/img/coins/64x64/21330.png",
  "APT": "https://s2.coinmarketcap.com/static/img/coins/64x64/21794.png",
  "ESHARE": "https://s2.coinmarketcap.com/static/img/coins/64x64/17613.png",
  "BIG": "https://s2.coinmarketcap.com/static/img/coins/64x64/22463.png",
  "LONG": "https://s2.coinmarketcap.com/static/img/coins/64x64/7668.png",
  "LIME": "https://s2.coinmarketcap.com/static/img/coins/64x64/10469.png",
  "VELO": "https://s2.coinmarketcap.com/static/img/coins/64x64/7127.png",
  "STOS": "https://s2.coinmarketcap.com/static/img/coins/64x64/9760.png",
  "SPS": "https://s2.coinmarketcap.com/static/img/coins/64x64/11035.png",
  "CYBER": "https://s2.coinmarketcap.com/static/img/coins/64x64/24781.png",
  "BONE": "https://s2.coinmarketcap.com/static/img/coins/64x64/11865.png",
  "ARB": "https://s2.coinmarketcap.com/static/img/coins/64x64/11841.png",
  "CRP": "https://s2.coinmarketcap.com/static/img/coins/64x64/6865.png",
  "QNT": "https://s2.coinmarketcap.com/static/img/coins/64x64/3155.png",
  "FXS": "https://s2.coinmarketcap.com/static/img/coins/64x64/6953.png",
  "FRAX": "https://s2.coinmarketcap.com/static/img/coins/64x64/6952.png",
  "AMKT": "https://s2.coinmarketcap.com/static/img/coins/64x64/22999.png",
  "TINU": "https://s2.coinmarketcap.com/static/img/coins/64x64/27739.png",
  "DPI": "https://s2.coinmarketcap.com/static/img/coins/64x64/7055.png",
  "TRUE": "https://s2.coinmarketcap.com/static/img/coins/64x64/2457.png",
  "ALT": "https://s2.coinmarketcap.com/static/img/coins/64x64/10897.png",
  "SHR": "https://s2.coinmarketcap.com/static/img/coins/64x64/4197.png",
  "MCC": "https://s2.coinmarketcap.com/static/img/coins/64x64/5595.png",
  "FOREX": "https://s2.coinmarketcap.com/static/img/coins/64x64/11794.png",
  "AAG": "https://s2.coinmarketcap.com/static/img/coins/64x64/15759.png",
  "BAG": "https://s2.coinmarketcap.com/static/img/coins/64x64/23415.png",
  "AMO": "https://s2.coinmarketcap.com/static/img/coins/64x64/3260.png",
  "XLM": "https://s2.coinmarketcap.com/static/img/coins/64x64/512.png",
  "REKT": "https://s2.coinmarketcap.com/static/img/coins/64x64/24633.png",
  "BTS": "https://s2.coinmarketcap.com/static/img/coins/64x64/463.png",
  "RMRK": "https://s2.coinmarketcap.com/static/img/coins/64x64/12140.png",
  "ALGO": "https://s2.coinmarketcap.com/static/img/coins/64x64/4030.png",
  "PG": "https://s2.coinmarketcap.com/static/img/coins/64x64/27723.png",
  "NEON": "https://s2.coinmarketcap.com/static/img/coins/64x64/23015.png",
  "LAVA": "https://s2.coinmarketcap.com/static/img/coins/64x64/8469.png",
  "ABLE": "https://s2.coinmarketcap.com/static/img/coins/64x64/11635.png",
  "XGC": "https://s2.coinmarketcap.com/static/img/coins/64x64/10436.png",
  "LET": "https://s2.coinmarketcap.com/static/img/coins/64x64/2468.png",
  "VAL": "https://s2.coinmarketcap.com/static/img/coins/64x64/1154.png",
  "POC": "https://s2.coinmarketcap.com/static/img/coins/64x64/13520.png",
  "BURN": "https://s2.coinmarketcap.com/static/img/coins/64x64/4069.png",
  "DIA": "https://s2.coinmarketcap.com/static/img/coins/64x64/6138.png",
  "WOLFIES": "https://s2.coinmarketcap.com/static/img/coins/64x64/19512.png",
  "NFTS": "https://s2.coinmarketcap.com/static/img/coins/64x64/10311.png",
  "TX": "https://s2.coinmarketcap.com/static/img/coins/64x64/23686.png",
  "LORDS": "https://s2.coinmarketcap.com/static/img/coins/64x64/17445.png",
  "PALM": "https://s2.coinmarketcap.com/static/img/coins/64x64/22442.png",
  "X2Y2": "https://s2.coinmarketcap.com/static/img/coins/64x64/18106.png",
  "KCS": "https://s2.coinmarketcap.com/static/img/coins/64x64/2087.png",
  "BAS": "https://s2.coinmarketcap.com/static/img/coins/64x64/7816.png",
  "BLD": "https://s2.coinmarketcap.com/static/img/coins/64x64/16697.png",
  "CAPS": "https://s2.coinmarketcap.com/static/img/coins/64x64/9291.png",
  "DF": "https://s2.coinmarketcap.com/static/img/coins/64x64/4758.png",
  "QRDO": "https://s2.coinmarketcap.com/static/img/coins/64x64/10750.png",
  "PUNDIX": "https://s2.coinmarketcap.com/static/img/coins/64x64/9040.png",
  "ZKS": "https://s2.coinmarketcap.com/static/img/coins/64x64/8202.png",
  "BTCS": "https://s2.coinmarketcap.com/static/img/coins/64x64/205.png",
  "LIT": "https://s2.coinmarketcap.com/static/img/coins/64x64/6833.png",
  "FITFI": "https://s2.coinmarketcap.com/static/img/coins/64x64/19778.png",
  "SAND": "https://s2.coinmarketcap.com/static/img/coins/64x64/6210.png",
  "TCP": "https://s2.coinmarketcap.com/static/img/coins/64x64/9416.png",
  "SHEN": "https://s2.coinmarketcap.com/static/img/coins/64x64/23115.png",
  "DJED": "https://s2.coinmarketcap.com/static/img/coins/64x64/21639.png",
  "WEB": "https://s2.coinmarketcap.com/static/img/coins/64x64/3027.png",
  "BTRFLY": "https://s2.coinmarketcap.com/static/img/coins/64x64/21324.png",
  "CRE": "https://s2.coinmarketcap.com/static/img/coins/64x64/3946.png",
  "DPX": "https://s2.coinmarketcap.com/static/img/coins/64x64/11188.png",
  "CHEQ": "https://s2.coinmarketcap.com/static/img/coins/64x64/12256.png",
  "MV": "https://s2.coinmarketcap.com/static/img/coins/64x64/17704.png",
  "GBEX": "https://s2.coinmarketcap.com/static/img/coins/64x64/19699.png",
  "OX": "https://s2.coinmarketcap.com/static/img/coins/64x64/26543.png",
  "ULX": "https://s2.coinmarketcap.com/static/img/coins/64x64/21524.png",
  "ULTRON": "https://s2.coinmarketcap.com/static/img/coins/64x64/24692.png",
  "PXP": "https://s2.coinmarketcap.com/static/img/coins/64x64/5640.png",
  "MLT": "https://s2.coinmarketcap.com/static/img/coins/64x64/9764.png",
  "DON": "https://s2.coinmarketcap.com/static/img/coins/64x64/9643.png",
  "KASTA": "https://s2.coinmarketcap.com/static/img/coins/64x64/16481.png",
  "PRE": "https://s2.coinmarketcap.com/static/img/coins/64x64/2245.png",
  "SAITO": "https://s2.coinmarketcap.com/static/img/coins/64x64/9194.png",
  "ROSE": "https://s2.coinmarketcap.com/static/img/coins/64x64/7653.png",
  "SNX": "https://s2.coinmarketcap.com/static/img/coins/64x64/2586.png",
  "SRM": "https://s2.coinmarketcap.com/static/img/coins/64x64/6187.png",
  "IOTX": "https://s2.coinmarketcap.com/static/img/coins/64x64/2777.png",
  "LEASH": "https://s2.coinmarketcap.com/static/img/coins/64x64/9286.png",
  "FET": "https://s2.coinmarketcap.com/static/img/coins/64x64/3773.png",
  "NXT": "https://s2.coinmarketcap.com/static/img/coins/64x64/66.png",
  "BOX": "https://s2.coinmarketcap.com/static/img/coins/64x64/2945.png",
  "POG": "https://s2.coinmarketcap.com/static/img/coins/64x64/23245.png",
  "SPORTS": "https://s2.coinmarketcap.com/static/img/coins/64x64/6564.png",
  "LDO": "https://s2.coinmarketcap.com/static/img/coins/64x64/8000.png",
  "O": "https://s2.coinmarketcap.com/static/img/coins/64x64/21831.png",
  "RUNE": "https://s2.coinmarketcap.com/static/img/coins/64x64/4157.png",
  "VLT": "https://s2.coinmarketcap.com/static/img/coins/64x64/1368.png",
  "SUN": "https://s2.coinmarketcap.com/static/img/coins/64x64/10529.png",
  "DGX": "https://s2.coinmarketcap.com/static/img/coins/64x64/2739.png",
  "777": "https://s2.coinmarketcap.com/static/img/coins/64x64/7305.png",
  "FTN": "https://s2.coinmarketcap.com/static/img/coins/64x64/22615.png",
  "MBX": "https://s2.coinmarketcap.com/static/img/coins/64x64/18895.png",
  "MYTH": "https://s2.coinmarketcap.com/static/img/coins/64x64/22125.png",
  "MONEY": "https://s2.coinmarketcap.com/static/img/coins/64x64/18758.png",
  "T": "https://s2.coinmarketcap.com/static/img/coins/64x64/17751.png",
  "ROCK": "https://s2.coinmarketcap.com/static/img/coins/64x64/24437.png",
  "LEO": "https://s2.coinmarketcap.com/static/img/coins/64x64/3957.png",
  "UFT": "https://s2.coinmarketcap.com/static/img/coins/64x64/7412.png",
  "VIX": "https://s2.coinmarketcap.com/static/img/coins/64x64/13298.png",
  "SHARES": "https://s2.coinmarketcap.com/static/img/coins/64x64/27901.png",
  "SWFTC": "https://s2.coinmarketcap.com/static/img/coins/64x64/2341.png",
  "BEAM": "https://s2.coinmarketcap.com/static/img/coins/64x64/3702.png",
  "QTUM": "https://s2.coinmarketcap.com/static/img/coins/64x64/1684.png",
  "LYXe": "https://s2.coinmarketcap.com/static/img/coins/64x64/5625.png",
  "HPO": "https://s2.coinmarketcap.com/static/img/coins/64x64/3600.png",
  "TRUTH": "https://s2.coinmarketcap.com/static/img/coins/64x64/24513.png",
  "BSV": "https://s2.coinmarketcap.com/static/img/coins/64x64/3602.png",
  "KEY": "https://s2.coinmarketcap.com/static/img/coins/64x64/2398.png",
  "STORE": "https://s2.coinmarketcap.com/static/img/coins/64x64/15207.png",
  "EMP": "https://s2.coinmarketcap.com/static/img/coins/64x64/23658.png",
  "FUSION": "https://s2.coinmarketcap.com/static/img/coins/64x64/27728.png",
  "SWEAT": "https://s2.coinmarketcap.com/static/img/coins/64x64/21351.png",
  "IMX": "https://s2.coinmarketcap.com/static/img/coins/64x64/10603.png",
  "POOL": "https://s2.coinmarketcap.com/static/img/coins/64x64/8508.png",
  "IOST": "https://s2.coinmarketcap.com/static/img/coins/64x64/2405.png",
  "CRO": "https://s2.coinmarketcap.com/static/img/coins/64x64/3635.png",
  "YFII": "https://s2.coinmarketcap.com/static/img/coins/64x64/5957.png",
  "PHA": "https://s2.coinmarketcap.com/static/img/coins/64x64/6841.png",
  "BAND": "https://s2.coinmarketcap.com/static/img/coins/64x64/4679.png",
  "UNLEASH": "https://s2.coinmarketcap.com/static/img/coins/64x64/27068.png",
  "BX": "https://s2.coinmarketcap.com/static/img/coins/64x64/17325.png",
  "GO": "https://s2.coinmarketcap.com/static/img/coins/64x64/2861.png",
  "ME": "https://s2.coinmarketcap.com/static/img/coins/64x64/6026.png",
  "INVEST": "https://s2.coinmarketcap.com/static/img/coins/64x64/10468.png",
  "HAI": "https://s2.coinmarketcap.com/static/img/coins/64x64/5583.png",
  "SOLVE": "https://s2.coinmarketcap.com/static/img/coins/64x64/3724.png",
  "PSL": "https://s2.coinmarketcap.com/static/img/coins/64x64/8738.png",
  "BZZ": "https://s2.coinmarketcap.com/static/img/coins/64x64/10293.png",
  "\$ADS": "https://s2.coinmarketcap.com/static/img/coins/64x64/11036.png",
  "ADS": "https://s2.coinmarketcap.com/static/img/coins/64x64/11036.png",
  "WELT": "https://s2.coinmarketcap.com/static/img/coins/64x64/14681.png",
  "VITA": "https://s2.coinmarketcap.com/static/img/coins/64x64/19214.png",
  "WOM": "https://s2.coinmarketcap.com/static/img/coins/64x64/19623.png",
  "DSLA": "https://s2.coinmarketcap.com/static/img/coins/64x64/5423.png",
  "TRAC": "https://s2.coinmarketcap.com/static/img/coins/64x64/2467.png",
  "QSP": "https://s2.coinmarketcap.com/static/img/coins/64x64/2212.png",
  "DIFX": "https://s2.coinmarketcap.com/static/img/coins/64x64/17690.png",
  "MCADE": "https://s2.coinmarketcap.com/static/img/coins/64x64/24303.png",
  "WING": "https://s2.coinmarketcap.com/static/img/coins/64x64/7048.png",
  "GSWIFT": "https://s2.coinmarketcap.com/static/img/coins/64x64/27445.png",
  "CHZ": "https://s2.coinmarketcap.com/static/img/coins/64x64/4066.png",
  "AURORA": "https://s2.coinmarketcap.com/static/img/coins/64x64/14803.png",
  "AUCTION": "https://s2.coinmarketcap.com/static/img/coins/64x64/8602.png",
  "LINA": "https://s2.coinmarketcap.com/static/img/coins/64x64/7102.png",
  "BSC": "https://s2.coinmarketcap.com/static/img/coins/64x64/993.png",
  "COMP": "https://s2.coinmarketcap.com/static/img/coins/64x64/5692.png",
  "TET": "https://s2.coinmarketcap.com/static/img/coins/64x64/21964.png",
  "XRD": "https://s2.coinmarketcap.com/static/img/coins/64x64/11948.png",
  "CLOUD": "https://s2.coinmarketcap.com/static/img/coins/64x64/22332.png",
  "LQTY": "https://s2.coinmarketcap.com/static/img/coins/64x64/7429.png",
  "FIO": "https://s2.coinmarketcap.com/static/img/coins/64x64/5865.png",
  "ALICE": "https://s2.coinmarketcap.com/static/img/coins/64x64/8766.png",
  "LAUNCH": "https://s2.coinmarketcap.com/static/img/coins/64x64/9279.png",
  "CRV": "https://s2.coinmarketcap.com/static/img/coins/64x64/6538.png",
  "KUB": "https://s2.coinmarketcap.com/static/img/coins/64x64/16093.png",
  "ACS": "https://s2.coinmarketcap.com/static/img/coins/64x64/23195.png",
  "OSMO": "https://s2.coinmarketcap.com/static/img/coins/64x64/12220.png",
  "CTX": "https://s2.coinmarketcap.com/static/img/coins/64x64/10368.png",
  "BOSON": "https://s2.coinmarketcap.com/static/img/coins/64x64/8827.png",
  "ENV": "https://s2.coinmarketcap.com/static/img/coins/64x64/12834.png",
  "CELR": "https://s2.coinmarketcap.com/static/img/coins/64x64/3814.png",
  "SFUND": "https://s2.coinmarketcap.com/static/img/coins/64x64/8972.png",
  "AP": "https://s2.coinmarketcap.com/static/img/coins/64x64/27200.png",
  "NTX": "https://s2.coinmarketcap.com/static/img/coins/64x64/13198.png",
  "FRA": "https://s2.coinmarketcap.com/static/img/coins/64x64/4249.png",
  "OOE": "https://s2.coinmarketcap.com/static/img/coins/64x64/9938.png",
  "BRWL": "https://s2.coinmarketcap.com/static/img/coins/64x64/19216.png",
  "ORCA": "https://s2.coinmarketcap.com/static/img/coins/64x64/11165.png",
  "SK": "https://s2.coinmarketcap.com/static/img/coins/64x64/17782.png",
  "NMR": "https://s2.coinmarketcap.com/static/img/coins/64x64/1732.png",
  "UOS": "https://s2.coinmarketcap.com/static/img/coins/64x64/4189.png",
  "ORBS": "https://s2.coinmarketcap.com/static/img/coins/64x64/3835.png",
  "SIDUS": "https://s2.coinmarketcap.com/static/img/coins/64x64/15463.png",
  "FUSE": "https://s2.coinmarketcap.com/static/img/coins/64x64/5634.png",
  "OKT": "https://s2.coinmarketcap.com/static/img/coins/64x64/8267.png",
  "XDB": "https://s2.coinmarketcap.com/static/img/coins/64x64/4566.png",
  "WAGMI": "https://s2.coinmarketcap.com/static/img/coins/64x64/25385.png",
  "FCT": "https://s2.coinmarketcap.com/static/img/coins/64x64/4953.png",
  "DEP": "https://s2.coinmarketcap.com/static/img/coins/64x64/5429.png",
  "NHCT": "https://s2.coinmarketcap.com/static/img/coins/64x64/19474.png",
  "LOVELY": "https://s2.coinmarketcap.com/static/img/coins/64x64/12365.png",
  "FDT": "https://s2.coinmarketcap.com/static/img/coins/64x64/19639.png",
  "WLD": "https://s2.coinmarketcap.com/static/img/coins/64x64/13502.png",
  "MCRT": "https://s2.coinmarketcap.com/static/img/coins/64x64/15721.png",
  "ELA": "https://s2.coinmarketcap.com/static/img/coins/64x64/2492.png",
  "LUNA": "https://s2.coinmarketcap.com/static/img/coins/64x64/20314.png",
  "SOY": "https://s2.coinmarketcap.com/static/img/coins/64x64/19879.png",
  "VEED": "https://s2.coinmarketcap.com/static/img/coins/64x64/11330.png",
  "ORDI": "https://s2.coinmarketcap.com/static/img/coins/64x64/25028.png",
  "CVX": "https://s2.coinmarketcap.com/static/img/coins/64x64/9903.png",
  "LON": "https://s2.coinmarketcap.com/static/img/coins/64x64/8083.png",
  "BAPE": "https://s2.coinmarketcap.com/static/img/coins/64x64/27773.png",
  "CHRP": "https://s2.coinmarketcap.com/static/img/coins/64x64/21722.png",
  "LSK": "https://s2.coinmarketcap.com/static/img/coins/64x64/1214.png",
  "GMM": "https://s2.coinmarketcap.com/static/img/coins/64x64/14304.png",
  "XPRT": "https://s2.coinmarketcap.com/static/img/coins/64x64/7281.png",
  "ALD": "https://s2.coinmarketcap.com/static/img/coins/64x64/10272.png",
  "UQC": "https://s2.coinmarketcap.com/static/img/coins/64x64/2273.png",
  "DOGPAD": "https://s2.coinmarketcap.com/static/img/coins/64x64/23331.png",
  "APEX": "https://s2.coinmarketcap.com/static/img/coins/64x64/19843.png",
  "APE": "https://s2.coinmarketcap.com/static/img/coins/64x64/18876.png",
  "LOOKS": "https://s2.coinmarketcap.com/static/img/coins/64x64/17081.png",
  "FAST": "https://s2.coinmarketcap.com/static/img/coins/64x64/23895.png",
  "TXA": "https://s2.coinmarketcap.com/static/img/coins/64x64/11278.png",
  "EVMOS": "https://s2.coinmarketcap.com/static/img/coins/64x64/19899.png",
  "KIN": "https://s2.coinmarketcap.com/static/img/coins/64x64/1993.png",
  "BFIC": "https://s2.coinmarketcap.com/static/img/coins/64x64/18736.png",
  "AIBB": "https://s2.coinmarketcap.com/static/img/coins/64x64/24742.png",
  "HIVE": "https://s2.coinmarketcap.com/static/img/coins/64x64/5370.png",
  "UTK": "https://s2.coinmarketcap.com/static/img/coins/64x64/2320.png",
  "COIN": "https://s2.coinmarketcap.com/static/img/coins/64x64/8068.png",
  "ANY": "https://s2.coinmarketcap.com/static/img/coins/64x64/5892.png",
  "DUST": "https://s2.coinmarketcap.com/static/img/coins/64x64/18802.png",
  "ILV": "https://s2.coinmarketcap.com/static/img/coins/64x64/8719.png",
  "XOR": "https://s2.coinmarketcap.com/static/img/coins/64x64/5802.png",
  "SPK": "https://s2.coinmarketcap.com/static/img/coins/64x64/2448.png",
  "KAVA": "https://s2.coinmarketcap.com/static/img/coins/64x64/4846.png",
  "BAL": "https://s2.coinmarketcap.com/static/img/coins/64x64/5728.png",
  "EURS": "https://s2.coinmarketcap.com/static/img/coins/64x64/2989.png",
  "BPT": "https://s2.coinmarketcap.com/static/img/coins/64x64/10402.png",
  "WMT": "https://s2.coinmarketcap.com/static/img/coins/64x64/13769.png",
  "AXL": "https://s2.coinmarketcap.com/static/img/coins/64x64/17799.png",
  "CET": "https://s2.coinmarketcap.com/static/img/coins/64x64/2941.png",
  "GEAR": "https://s2.coinmarketcap.com/static/img/coins/64x64/16360.png",
  "LUSD": "https://s2.coinmarketcap.com/static/img/coins/64x64/9566.png",
  "ENO": "https://s2.coinmarketcap.com/static/img/coins/64x64/21118.png",
  "RETH": "https://s2.coinmarketcap.com/static/img/coins/64x64/15060.png",
  "CFX": "https://s2.coinmarketcap.com/static/img/coins/64x64/7334.png",
  "USDX": "https://s2.coinmarketcap.com/static/img/coins/64x64/6651.png",
  "TSX": "https://s2.coinmarketcap.com/static/img/coins/64x64/9563.png",
  "GLM": "https://s2.coinmarketcap.com/static/img/coins/64x64/1455.png",
  "BIN": "https://s2.coinmarketcap.com/static/img/coins/64x64/11412.png",
  "CEEK": "https://s2.coinmarketcap.com/static/img/coins/64x64/2856.png",
  "TRU": "https://s2.coinmarketcap.com/static/img/coins/64x64/7725.png",
  "SUV": "https://s2.coinmarketcap.com/static/img/coins/64x64/4688.png",
  "GAFI": "https://s2.coinmarketcap.com/static/img/coins/64x64/11783.png",
  "MTS": "https://s2.coinmarketcap.com/static/img/coins/64x64/16033.png",
  "DIP": "https://s2.coinmarketcap.com/static/img/coins/64x64/6588.png",
  "MTVT": "https://s2.coinmarketcap.com/static/img/coins/64x64/15974.png",
  "SPT": "https://s2.coinmarketcap.com/static/img/coins/64x64/26655.png",
  "BTF": "https://s2.coinmarketcap.com/static/img/coins/64x64/7845.png",
  "ORAI": "https://s2.coinmarketcap.com/static/img/coins/64x64/7533.png",
  "BDX": "https://s2.coinmarketcap.com/static/img/coins/64x64/3987.png",
  "FDUSD": "https://s2.coinmarketcap.com/static/img/coins/64x64/26081.png",
  "AR": "https://s2.coinmarketcap.com/static/img/coins/64x64/5632.png",
  "PMR": "https://s2.coinmarketcap.com/static/img/coins/64x64/22712.png",
  "OMI": "https://s2.coinmarketcap.com/static/img/coins/64x64/19075.png",
  "IGU": "https://s2.coinmarketcap.com/static/img/coins/64x64/20349.png",
  "MBD": "https://s2.coinmarketcap.com/static/img/coins/64x64/20188.png",
  "UNFI": "https://s2.coinmarketcap.com/static/img/coins/64x64/7672.png",
  "YARA": "https://s2.coinmarketcap.com/static/img/coins/64x64/25887.png",
  "FTP": "https://s2.coinmarketcap.com/static/img/coins/64x64/18486.png",
  "SCS": "https://s2.coinmarketcap.com/static/img/coins/64x64/25101.png",
  "BOBA": "https://s2.coinmarketcap.com/static/img/coins/64x64/14556.png",
  "CHS": "https://s2.coinmarketcap.com/static/img/coins/64x64/9390.png",
  "ATR": "https://s2.coinmarketcap.com/static/img/coins/64x64/19131.png",
  "BTT": "https://s2.coinmarketcap.com/static/img/coins/64x64/16086.png",
  "PLANET": "https://s2.coinmarketcap.com/static/img/coins/64x64/26585.png",
  "FRY": "https://s2.coinmarketcap.com/static/img/coins/64x64/23739.png",
  "BEN": "https://s2.coinmarketcap.com/static/img/coins/64x64/25047.png",
  "SVT": "https://s2.coinmarketcap.com/static/img/coins/64x64/17290.png",
  "EGX": "https://s2.coinmarketcap.com/static/img/coins/64x64/15530.png",
  "PDT": "https://s2.coinmarketcap.com/static/img/coins/64x64/17794.png",
  "AMB": "https://s2.coinmarketcap.com/static/img/coins/64x64/2081.png",
  "RAM": "https://s2.coinmarketcap.com/static/img/coins/64x64/8798.png",
  "GB": "https://s2.coinmarketcap.com/static/img/coins/64x64/1285.png",
  "EST": "https://s2.coinmarketcap.com/static/img/coins/64x64/3073.png",
  "EM": "https://s2.coinmarketcap.com/static/img/coins/64x64/4215.png",
  "ELEPHANT": "https://s2.coinmarketcap.com/static/img/coins/64x64/9936.png",
  "DAX": "https://s2.coinmarketcap.com/static/img/coins/64x64/2696.png",
  "KOYO": "https://s2.coinmarketcap.com/static/img/coins/64x64/22120.png",
  "NAME": "https://s2.coinmarketcap.com/static/img/coins/64x64/9264.png",
  "NKN": "https://s2.coinmarketcap.com/static/img/coins/64x64/2780.png",
  "DBR": "https://s2.coinmarketcap.com/static/img/coins/64x64/23006.png",
  "ATH": "https://s2.coinmarketcap.com/static/img/coins/64x64/20483.png",
  "VGX": "https://s2.coinmarketcap.com/static/img/coins/64x64/1817.png",
  "VVS": "https://s2.coinmarketcap.com/static/img/coins/64x64/14519.png",
  "RAI": "https://s2.coinmarketcap.com/static/img/coins/64x64/8525.png",
  "INFRA": "https://s2.coinmarketcap.com/static/img/coins/64x64/9052.png",
  "NONE": "https://s2.coinmarketcap.com/static/img/coins/64x64/27851.png",
  "SHIA": "https://s2.coinmarketcap.com/static/img/coins/64x64/27922.png",
  "OCTA": "https://s2.coinmarketcap.com/static/img/coins/64x64/24261.png",
  "HUNT": "https://s2.coinmarketcap.com/static/img/coins/64x64/5380.png",
  "GHX": "https://s2.coinmarketcap.com/static/img/coins/64x64/6554.png",
  "DIO": "https://s2.coinmarketcap.com/static/img/coins/64x64/3908.png",
  "GLCH": "https://s2.coinmarketcap.com/static/img/coins/64x64/8236.png",
  "THC": "https://s2.coinmarketcap.com/static/img/coins/64x64/416.png",
  "SNM": "https://s2.coinmarketcap.com/static/img/coins/64x64/9931.png",
  "ATL": "https://s2.coinmarketcap.com/static/img/coins/64x64/2136.png",
  "RLTM": "https://s2.coinmarketcap.com/static/img/coins/64x64/24106.png",
  "LFG": "https://s2.coinmarketcap.com/static/img/coins/64x64/11086.png",
  "FCC": "https://s2.coinmarketcap.com/static/img/coins/64x64/498.png",
  "WAIT": "https://s2.coinmarketcap.com/static/img/coins/64x64/21997.png",
  "OATH": "https://s2.coinmarketcap.com/static/img/coins/64x64/18520.png",
  "PPI": "https://s2.coinmarketcap.com/static/img/coins/64x64/19544.png",
  "GTH": "https://s2.coinmarketcap.com/static/img/coins/64x64/7041.png",
  "MIM": "https://s2.coinmarketcap.com/static/img/coins/64x64/21557.png",
  "TAROT": "https://s2.coinmarketcap.com/static/img/coins/64x64/11409.png",
  "EWT": "https://s2.coinmarketcap.com/static/img/coins/64x64/5268.png",
  "KILT": "https://s2.coinmarketcap.com/static/img/coins/64x64/6830.png",
  "WXT": "https://s2.coinmarketcap.com/static/img/coins/64x64/4090.png",
  "BMAX": "https://s2.coinmarketcap.com/static/img/coins/64x64/21007.png",
  "NYC": "https://s2.coinmarketcap.com/static/img/coins/64x64/298.png",
  "QR": "https://s2.coinmarketcap.com/static/img/coins/64x64/24292.png",
  "UPP": "https://s2.coinmarketcap.com/static/img/coins/64x64/2866.png",
  "DAO": "https://s2.coinmarketcap.com/static/img/coins/64x64/8420.png",
  "WE": "https://s2.coinmarketcap.com/static/img/coins/64x64/20456.png",
  "MUST": "https://s2.coinmarketcap.com/static/img/coins/64x64/8294.png",
  "NOW": "https://s2.coinmarketcap.com/static/img/coins/64x64/3893.png",
  "LIVE": "https://s2.coinmarketcap.com/static/img/coins/64x64/6889.png",
  "IOT": "https://s2.coinmarketcap.com/static/img/coins/64x64/24686.png",
  "LCX": "https://s2.coinmarketcap.com/static/img/coins/64x64/4950.png",
  "AG": "https://s2.coinmarketcap.com/static/img/coins/64x64/19540.png",
  "CV": "https://s2.coinmarketcap.com/static/img/coins/64x64/27394.png",
  "XP": "https://s2.coinmarketcap.com/static/img/coins/64x64/11842.png",
  "TARA": "https://s2.coinmarketcap.com/static/img/coins/64x64/8715.png",
  "PLAY": "https://s2.coinmarketcap.com/static/img/coins/64x64/24400.png",
  "LING": "https://s2.coinmarketcap.com/static/img/coins/64x64/21796.png",
  "BCH": "https://s2.coinmarketcap.com/static/img/coins/64x64/1831.png",
  "SOMM": "https://s2.coinmarketcap.com/static/img/coins/64x64/18248.png",
  "DMT": "https://s2.coinmarketcap.com/static/img/coins/64x64/25653.png",
  "CHSB": "https://s2.coinmarketcap.com/static/img/coins/64x64/2499.png",
  "YLD": "https://s2.coinmarketcap.com/static/img/coins/64x64/8066.png",
  "YIELD": "https://s2.coinmarketcap.com/static/img/coins/64x64/7498.png",
  "FOR": "https://s2.coinmarketcap.com/static/img/coins/64x64/4118.png",
  "FREE": "https://s2.coinmarketcap.com/static/img/coins/64x64/3388.png",
  "OAS": "https://s2.coinmarketcap.com/static/img/coins/64x64/22265.png",
  "VR": "https://s2.coinmarketcap.com/static/img/coins/64x64/14822.png",
  "DC": "https://s2.coinmarketcap.com/static/img/coins/64x64/21414.png",
  "ICX": "https://s2.coinmarketcap.com/static/img/coins/64x64/2099.png",
  "REQ": "https://s2.coinmarketcap.com/static/img/coins/64x64/2071.png",
  "CRM": "https://s2.coinmarketcap.com/static/img/coins/64x64/1850.png",
  "LVL": "https://s2.coinmarketcap.com/static/img/coins/64x64/23119.png",
  "EVER": "https://s2.coinmarketcap.com/static/img/coins/64x64/7505.png",
  "IM": "https://s2.coinmarketcap.com/static/img/coins/64x64/23392.png",
  "BIS": "https://s2.coinmarketcap.com/static/img/coins/64x64/2009.png",
  "GEM": "https://s2.coinmarketcap.com/static/img/coins/64x64/22176.png",
  "PAY": "https://s2.coinmarketcap.com/static/img/coins/64x64/1758.png",
  "DGEN": "https://s2.coinmarketcap.com/static/img/coins/64x64/27734.png",
  "VSL": "https://s2.coinmarketcap.com/static/img/coins/64x64/22618.png",
  "PINKSALE": "https://s2.coinmarketcap.com/static/img/coins/64x64/12566.png",
  "GMT": "https://s2.coinmarketcap.com/static/img/coins/64x64/18069.png",
  "DNA": "https://s2.coinmarketcap.com/static/img/coins/64x64/5234.png",
  "PROB": "https://s2.coinmarketcap.com/static/img/coins/64x64/4586.png",
  "MMO": "https://s2.coinmarketcap.com/static/img/coins/64x64/3449.png",
  "BG": "https://s2.coinmarketcap.com/static/img/coins/64x64/15313.png",
  "LOOT": "https://s2.coinmarketcap.com/static/img/coins/64x64/27598.png",
  "CODE": "https://s2.coinmarketcap.com/static/img/coins/64x64/21522.png",
  "XCAD": "https://s2.coinmarketcap.com/static/img/coins/64x64/9868.png",
  "WIFI": "https://s2.coinmarketcap.com/static/img/coins/64x64/24133.png",
  "PLS": "https://s2.coinmarketcap.com/static/img/coins/64x64/11145.png",
  "INF": "https://s2.coinmarketcap.com/static/img/coins/64x64/1880.png",
  "BTR": "https://s2.coinmarketcap.com/static/img/coins/64x64/4167.png",
  "\$HOLA": "https://s2.coinmarketcap.com/static/img/coins/64x64/27272.png",
  "HOLA": "https://s2.coinmarketcap.com/static/img/coins/64x64/27272.png",
  "HDX": "https://s2.coinmarketcap.com/static/img/coins/64x64/6753.png",
  "LAT": "https://s2.coinmarketcap.com/static/img/coins/64x64/9720.png",
  "MAHA": "https://s2.coinmarketcap.com/static/img/coins/64x64/8043.png",
  "IPOR": "https://s2.coinmarketcap.com/static/img/coins/64x64/22880.png",
  "PART": "https://s2.coinmarketcap.com/static/img/coins/64x64/1826.png",
  "888": "https://s2.coinmarketcap.com/static/img/coins/64x64/6051.png",
  "DASH": "https://s2.coinmarketcap.com/static/img/coins/64x64/131.png",
  "TON": "https://s2.coinmarketcap.com/static/img/coins/64x64/11419.png",
  "ALBT": "https://s2.coinmarketcap.com/static/img/coins/64x64/6957.png",
  "HTR": "https://s2.coinmarketcap.com/static/img/coins/64x64/5552.png",
  "CVP": "https://s2.coinmarketcap.com/static/img/coins/64x64/6669.png",
  "KEI": "https://s2.coinmarketcap.com/static/img/coins/64x64/24481.png",
  "ESG": "https://s2.coinmarketcap.com/static/img/coins/64x64/19483.png",
  "SALE": "https://s2.coinmarketcap.com/static/img/coins/64x64/6742.png",
  "KOM": "https://s2.coinmarketcap.com/static/img/coins/64x64/10403.png",
  "BB": "https://s2.coinmarketcap.com/static/img/coins/64x64/15231.png",
  "AFC": "https://s2.coinmarketcap.com/static/img/coins/64x64/11532.png",
  "MAY": "https://s2.coinmarketcap.com/static/img/coins/64x64/25932.png",
  "PIN": "https://s2.coinmarketcap.com/static/img/coins/64x64/64.png",
  "NAKA": "https://s2.coinmarketcap.com/static/img/coins/64x64/12749.png",
  "XAVA": "https://s2.coinmarketcap.com/static/img/coins/64x64/9797.png",
  "ZPAY": "https://s2.coinmarketcap.com/static/img/coins/64x64/10929.png",
  "GPT": "https://s2.coinmarketcap.com/static/img/coins/64x64/24281.png",
  "CASH": "https://s2.coinmarketcap.com/static/img/coins/64x64/5038.png",
  "BELIEVE": "https://s2.coinmarketcap.com/static/img/coins/64x64/23358.png",
  "ACA": "https://s2.coinmarketcap.com/static/img/coins/64x64/6756.png",
  "WIN": "https://s2.coinmarketcap.com/static/img/coins/64x64/4206.png",
  "SKILL": "https://s2.coinmarketcap.com/static/img/coins/64x64/9654.png",
  "NOAH": "https://s2.coinmarketcap.com/static/img/coins/64x64/458.png",
  "GHO": "https://s2.coinmarketcap.com/static/img/coins/64x64/23508.png",
  "GFX": "https://s2.coinmarketcap.com/static/img/coins/64x64/9018.png",
  "LIFE": "https://s2.coinmarketcap.com/static/img/coins/64x64/11700.png",
  "SAKAI": "https://s2.coinmarketcap.com/static/img/coins/64x64/23577.png",
  "ADM": "https://s2.coinmarketcap.com/static/img/coins/64x64/3703.png",
  "ABI": "https://s2.coinmarketcap.com/static/img/coins/64x64/16418.png",
  "OM": "https://s2.coinmarketcap.com/static/img/coins/64x64/6536.png",
  "WELL": "https://s2.coinmarketcap.com/static/img/coins/64x64/20734.png",
  "VOLT": "https://s2.coinmarketcap.com/static/img/coins/64x64/19650.png",
  "ISP": "https://s2.coinmarketcap.com/static/img/coins/64x64/9865.png",
  "CSPR": "https://s2.coinmarketcap.com/static/img/coins/64x64/5899.png",
  "ASTRA": "https://s2.coinmarketcap.com/static/img/coins/64x64/18519.png",
  "PAXG": "https://s2.coinmarketcap.com/static/img/coins/64x64/4705.png",
  "PYR": "https://s2.coinmarketcap.com/static/img/coins/64x64/9308.png",
  "AMPL": "https://s2.coinmarketcap.com/static/img/coins/64x64/4056.png",
  "SDAO": "https://s2.coinmarketcap.com/static/img/coins/64x64/9638.png",
  "SBTC": "https://s2.coinmarketcap.com/static/img/coins/64x64/2282.png",
  "BFF": "https://s2.coinmarketcap.com/static/img/coins/64x64/3300.png",
  "CAN": "https://s2.coinmarketcap.com/static/img/coins/64x64/8537.png",
  "VENOM": "https://s2.coinmarketcap.com/static/img/coins/64x64/22059.png",
  "WAL": "https://s2.coinmarketcap.com/static/img/coins/64x64/16034.png",
  "HAPI": "https://s2.coinmarketcap.com/static/img/coins/64x64/8567.png",
  "MRST": "https://s2.coinmarketcap.com/static/img/coins/64x64/12826.png",
  "CBT": "https://s2.coinmarketcap.com/static/img/coins/64x64/9342.png",
  "DTC": "https://s2.coinmarketcap.com/static/img/coins/64x64/25228.png",
  "EL": "https://s2.coinmarketcap.com/static/img/coins/64x64/5382.png",
  "SHILL": "https://s2.coinmarketcap.com/static/img/coins/64x64/10462.png",
  "AER": "https://s2.coinmarketcap.com/static/img/coins/64x64/27595.png",
  "KAS": "https://s2.coinmarketcap.com/static/img/coins/64x64/20396.png",
  "SDEX": "https://s2.coinmarketcap.com/static/img/coins/64x64/24203.png",
  "PLI": "https://s2.coinmarketcap.com/static/img/coins/64x64/14188.png",
  "GAME": "https://s2.coinmarketcap.com/static/img/coins/64x64/576.png",
  "RARE": "https://s2.coinmarketcap.com/static/img/coins/64x64/11294.png",
  "ASTR": "https://s2.coinmarketcap.com/static/img/coins/64x64/12885.png",
  "AXS": "https://s2.coinmarketcap.com/static/img/coins/64x64/6783.png",
  "ES": "https://s2.coinmarketcap.com/static/img/coins/64x64/4860.png",
  "RBX": "https://s2.coinmarketcap.com/static/img/coins/64x64/23464.png",
  "IDEX": "https://s2.coinmarketcap.com/static/img/coins/64x64/3928.png",
  "SPACE": "https://s2.coinmarketcap.com/static/img/coins/64x64/24193.png",
  "AVAX": "https://s2.coinmarketcap.com/static/img/coins/64x64/5805.png",
  "BAY": "https://s2.coinmarketcap.com/static/img/coins/64x64/25431.png",
  "FTT": "https://s2.coinmarketcap.com/static/img/coins/64x64/4195.png",
  "NANA": "https://s2.coinmarketcap.com/static/img/coins/64x64/24744.png",
  "ERA": "https://s2.coinmarketcap.com/static/img/coins/64x64/18483.png",
  "LBK": "https://s2.coinmarketcap.com/static/img/coins/64x64/5445.png",
  "LUCKY": "https://s2.coinmarketcap.com/static/img/coins/64x64/22192.png",
  "BANK": "https://s2.coinmarketcap.com/static/img/coins/64x64/8612.png",
  "RDNT": "https://s2.coinmarketcap.com/static/img/coins/64x64/21106.png",
  "LABS": "https://s2.coinmarketcap.com/static/img/coins/64x64/8813.png",
  "ACX": "https://s2.coinmarketcap.com/static/img/coins/64x64/22620.png",
  "SCAM": "https://s2.coinmarketcap.com/static/img/coins/64x64/27094.png",
  "COPI": "https://s2.coinmarketcap.com/static/img/coins/64x64/15563.png",
  "OKB": "https://s2.coinmarketcap.com/static/img/coins/64x64/3897.png",
  "MBS": "https://s2.coinmarketcap.com/static/img/coins/64x64/13011.png",
  "PRO": "https://s2.coinmarketcap.com/static/img/coins/64x64/1974.png",
  "SWIFT": "https://s2.coinmarketcap.com/static/img/coins/64x64/3933.png",
  "TURBO": "https://s2.coinmarketcap.com/static/img/coins/64x64/24911.png",
  "EJS": "https://s2.coinmarketcap.com/static/img/coins/64x64/11088.png",
  "VAI": "https://s2.coinmarketcap.com/static/img/coins/64x64/7824.png",
  "PNK": "https://s2.coinmarketcap.com/static/img/coins/64x64/3581.png",
  "USDD": "https://s2.coinmarketcap.com/static/img/coins/64x64/19891.png",
  "LYO": "https://s2.coinmarketcap.com/static/img/coins/64x64/20632.png",
  "NFA": "https://s2.coinmarketcap.com/static/img/coins/64x64/22972.png",
  "GM": "https://s2.coinmarketcap.com/static/img/coins/64x64/14271.png",
  "OPUL": "https://s2.coinmarketcap.com/static/img/coins/64x64/10409.png",
  "MAGIC": "https://s2.coinmarketcap.com/static/img/coins/64x64/14783.png",
  "BC": "https://s2.coinmarketcap.com/static/img/coins/64x64/3976.png",
  "FLOW": "https://s2.coinmarketcap.com/static/img/coins/64x64/4558.png",
  "BEST": "https://s2.coinmarketcap.com/static/img/coins/64x64/4361.png",
  "ET": "https://s2.coinmarketcap.com/static/img/coins/64x64/22069.png",
  "PVP": "https://s2.coinmarketcap.com/static/img/coins/64x64/26046.png",
  "HOOK": "https://s2.coinmarketcap.com/static/img/coins/64x64/22764.png",
  "BREED": "https://s2.coinmarketcap.com/static/img/coins/64x64/19722.png",
  "XAUt": "https://s2.coinmarketcap.com/static/img/coins/64x64/5176.png",
  "IST": "https://s2.coinmarketcap.com/static/img/coins/64x64/22736.png",
  "BNBX": "https://s2.coinmarketcap.com/static/img/coins/64x64/21534.png",
  "XVS": "https://s2.coinmarketcap.com/static/img/coins/64x64/7288.png",
  "MET": "https://s2.coinmarketcap.com/static/img/coins/64x64/2873.png",
  "LC": "https://s2.coinmarketcap.com/static/img/coins/64x64/20170.png",
  "BCX": "https://s2.coinmarketcap.com/static/img/coins/64x64/2281.png",
  "URUS": "https://s2.coinmarketcap.com/static/img/coins/64x64/8616.png",
  "RSR": "https://s2.coinmarketcap.com/static/img/coins/64x64/3964.png",
  "BICO": "https://s2.coinmarketcap.com/static/img/coins/64x64/9543.png",
  "CIRUS": "https://s2.coinmarketcap.com/static/img/coins/64x64/11578.png",
  "QMALL": "https://s2.coinmarketcap.com/static/img/coins/64x64/18059.png",
  "SB": "https://s2.coinmarketcap.com/static/img/coins/64x64/14027.png",
  "HIP": "https://s2.coinmarketcap.com/static/img/coins/64x64/10297.png",
  "WOO": "https://s2.coinmarketcap.com/static/img/coins/64x64/7501.png",
  "NEXO": "https://s2.coinmarketcap.com/static/img/coins/64x64/2694.png",
  "HYDRA": "https://s2.coinmarketcap.com/static/img/coins/64x64/8245.png",
  "SDF": "https://s2.coinmarketcap.com/static/img/coins/64x64/21723.png",
  "IC": "https://s2.coinmarketcap.com/static/img/coins/64x64/24100.png",
  "CCD": "https://s2.coinmarketcap.com/static/img/coins/64x64/18031.png",
  "CGPT": "https://s2.coinmarketcap.com/static/img/coins/64x64/23756.png",
  "GRND": "https://s2.coinmarketcap.com/static/img/coins/64x64/21706.png",
  "MKR": "https://s2.coinmarketcap.com/static/img/coins/64x64/1518.png",
  "DIS": "https://s2.coinmarketcap.com/static/img/coins/64x64/25725.png",
  "MEGA": "https://s2.coinmarketcap.com/static/img/coins/64x64/23854.png"
};